import { DiscountType } from "@/data/model/Enums";

import { logError } from "@/shared/logging/errors";

import { Popup } from "@/components/dialog/Popup";

import EnterDiscountOpenValuePopover from "@/app/components/discount/EnterDiscountOpenValuePopover.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";
import { translations } from "@/shared/localization/translations";

export class EnterDiscountOpenValuePopoverVue extends VueContentPopover {
    constructor(options: {
        onEnterValue: (value: number) => void;
        discountType: DiscountType;
        uniqueId: string | undefined;
    }) {
        super({
            popoverClass: "enter-discount-open-value-popover",
            flexHeight: true,
            title: translations.discounts.value,
            condensed: true,
            uniqueId: options.uniqueId,
        });

        try {
            const props = {
                onEnterValue: options.onEnterValue,
                discountType: options.discountType,
                hide: () => this.hide(),
                updateBodyHeight: () => this.updateBodyHeight(),
            };
            this.initComponent(EnterDiscountOpenValuePopover, props);
        } catch (ex) {
            logError(ex);
            Popup.show({ message: "Error showing done popover" });
            this.hide();
        }
    }
}
